import {Component, Input, OnInit} from '@angular/core';
import {Intervento} from "../../../Interventi/Models/Intervento";
import {ApiRestService} from "../../_service/api-rest.service";
import {ApiRestService as PersonaleApiRestService} from "../../../Admin/_service/api-rest.service";
import {DatePipe} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Task} from "../../models/Task";
import {AttivitaTaskEditComponent} from "../attivita-edit/attivita-task-edit.component";
import {Permission} from "../../../Login/_guards/Permission";
import {Persona} from "../../../Admin/models/persona";
import {RicercaPaginazione} from "../../../Admin/models/sendpersonale";
import {AuthenticationService} from "../../../Login/_services/authentication.service";
import {environment} from "../../../../environments/environment";
import {CampoAggiuntivo, CampoUtility} from "../../../shared/models/campo-aggiuntivo";
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown';
import {ActivatedRoute} from "@angular/router";
import {ApiPathsService} from "../../../api-paths.service";
import {objectKeys} from "codelyzer/util/objectKeys";

@Component({
  selector: 'app-attivita-lista',
  templateUrl: './attivita-lista.component.html'
})
export class AttivitaListaComponent implements OnInit {
  List: Intervento[];
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  closedDS:IDropdownSettings ={
    singleSelection: true,
    singleOutput:true,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'label',
  };
  prodottidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'seriale',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clientiselezionati: any;
  clienti: any;
  managers: Persona[] = [];
  managerselezionati: any[] = [];
  today = new Date();
  environment=environment;
  mese = this.today.getMonth();
  anno = this.today.getFullYear();
  tipi = [];
  @Input() giorno: string = this.datepipe.transform(this.today, 'yyyy-MM-dd');
  inizio: string = this.datepipe.transform(new Date(this.anno,this.mese,1), 'yyyy-MM-dd');
  fine: string = this.datepipe.transform(new Date(this.anno,this.mese+1,0), 'yyyy-MM-dd');
  Stampe: any[];
  tipoObject: { id: any };
  stato: {id:any};
  stati: any[];
  filtro: any = {};
  prodotti: any = [];
  prodottiselezionati: any[];
  bup: any[] = [];
  ordine: { field: string; order: 'asc' | 'desc' };
  constructor(
    public campoUtility: CampoUtility,
    private apiRestService: ApiRestService,
    private apiPaths: ApiPathsService,
    private personaleApiRestService: PersonaleApiRestService,
    private datepipe: DatePipe,
    private modalService: NgbModal,
    public permission: Permission,
    private authSvc: AuthenticationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.getTipi();
    var filter = {page: 0, size: 10, chiuso: this.closedf?.id,approvazione: this.Approvato?.id, inizio: this.periodo ? this.inizio: null, fine: this.periodo ? this.fine : null, periodo: this.periodo, tecnici: this.managerselezionati?.map(x=>x.id), clienti: this.clientiselezionati?.map(x=>x.id), prove: this.prodottiselezionati?.map(x=>x.id)};
    this.route.params.subscribe(data => {
      this.route.queryParams
        .subscribe(params => {
            Object.getOwnPropertyNames(params)?.forEach(prop => {
             if(prop == 'inizio')
              this.inizio = params[prop];
             if(prop == 'fine')
               this.fine = params[prop];
             if(prop == 'cliente')
               this.clientiselezionati = [{id: params[prop]}];
             if(prop == 'operatore')
               this.managerselezionati = [{id: params[prop]}];
              if(prop == 'tipo')
                this.tipoObject = {id: params[prop]};
              if(prop == 'approvato')
                this.Approvato = {id: params[prop], label:""};
              if(prop == 'chiuso')
                this.closedf = {id: params[prop]==1 || params[prop]=="true", label:params[prop]==1 || params[prop]=="true" ? "Chiuso" : "Non Chiuso"};
              if(prop == 'periodo')
                this.periodo = params[prop]==1 || params[prop]=="true";
            })
          this.refresh();
          }
        );
      /*this.Refresh();*/
    })

  }
  filtroProdotti(s: string = "") {
    this.refresh();
    if(this.clientiselezionati?.find(x=>true).id)
      this.apiRestService.getProveAcquistoCliente({id:this.clientiselezionati?.find(x=>true).id}).subscribe(data=>this.prodotti = data?.data);
  }
  filtroCliente(event: string) {
    if (event.length >= 3)
      this.personaleApiRestService.getListaAziende(new RicercaPaginazione(event, 0, 1)).subscribe(data=>this.clienti = data?.data);
  }

  refresh(filter?){
    var filtro = filter ?? {page: 0, size: 10, chiuso: this.closedf?.id, tipo: this.tipoObject?.id,stato: this.stato?.id, approvazione: this.Approvato?.id, inizio: this.periodo ? this.inizio: null, fine: this.periodo ? this.fine : null, periodo: this.periodo, tecnici: this.managerselezionati?.map(x=>x.id), clienti: this.clientiselezionati?.map(x=>x.id), prove: this.prodottiselezionati?.map(x=>x.id)};


    this.apiRestService.getAttivita(Object.assign({}, this.filtro ?? {}, filtro)).subscribe(data=> {
      this.List = data?.data ?? [];
      this.Stampe = data?.stampe ?? [];
      this.bup = Object.assign([], this.List);
    })
  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleApiRestService.getListaPersonale(new RicercaPaginazione(item, 0, 1)).subscribe(data=>{
        this.managers = data?.data;
      });
    }
  }
  Header() {
    return environment.RmaAddOn['headersTaskboard'].filter(x=>this.campoUtility.Show(x,{},false))
  }
  Edit(task?: Task) {
    let editmodal = this.modalService.open(AttivitaTaskEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AttivitaTaskEditComponent>editmodal.componentInstance).IsModal = true;
    (<AttivitaTaskEditComponent>editmodal.componentInstance).Item = task? Object.assign({}, task) : new Task(this.authSvc.currentUserValue);
    (<AttivitaTaskEditComponent>editmodal.componentInstance).updated.subscribe(data=> {this.refresh()});
  }

  Delete(task: Task){
    if(confirm(""))
      this.apiRestService.deleteAttivita(task).subscribe(()=>this.refresh());
  }
  Warning(item: Task): string {
    var output = '';
    item.figli?.filter(x => x.managerObject?.id == this.authSvc.currentUserValue.id && !x.data_fine_effettiva)?.forEach(x=>{
      output = output + ' '+ x.nome + '\n';
    })
    return output;
  }
  WarningNoResp(item: Task): string {
    var output = '';
    item.figli?.filter(x => !x.managerObject?.id  && !x.data_fine_effettiva)?.forEach(x=>{
      output = output + ' '+ x.nome + '\n';
    })
    return output;
  }
  tag(item: Task): string {
    var output = '';
    item.figli?.filter(x => x?.note?.includes('@' + this.authSvc.currentUserValue.username) && !x.data_fine_effettiva)?.forEach(x=>{
      output = output + ' '+ x.nome + '\n';
    })
    return output;
  }
  getTipi(){
    this.apiPaths.ClassicPost('/settings/get', {id: "tipo_intervento", type:"tipo_intervento"}).subscribe(data => {
      this.tipi = data;
    })
    this.apiPaths.ClassicPost('/settings/get', {id: "stato_intervento", type:"stato_intervento"}).subscribe(data => {
      this.stati = data;
    })
  }
  order(campo: CampoAggiuntivo) {
    var order: 'asc' | 'desc' = campo.nome == this.ordine?.field ? (this.ordine.order == 'asc' ? 'desc' : 'asc') : 'asc'

    this.List = this.campoUtility.getSortedList(this.bup, campo, order);
    this.ordine = {field: campo.nome, order: order}
  }
  
  protected readonly closed = closed;
  closedf: {id: boolean, label:string} //= this.permission.isntOperativeRole('U') ? {id: true, label:'Chiuso'} : {id: false, label:'Non Chiuso'};
  Approvato: {id: boolean, label:string} = null
  periodo: boolean = true;
}
